import { Box } from "@mui/material";
import Map from "../components/Map";
import FireScarsLayer from "../components/layer_components/FireScarsLayer";
import LayersToolbar from "../components/toolbar/LayersToolbar";

const fireScarsTileJson = {
  tiles: [
    "https://ksppusijlkc2gqynq5upxkaaua0pusbj.lambda-url.ap-southeast-2.on.aws/cog/tiles/WebMercatorQuad/{z}/{x}/{y}@1x?url=s3%3A%2F%2Ffire-scar-data-prod%2FCOG-test%2F06a_cog.tif",
  ],
  minzoom: 3,
  maxzoom: 12,
  bounds: [
    113.338953078,
    -43.63473221547958,
    153.56927158355882,
    -10.6681857235,
  ] as [number, number, number, number],
};

export default function DetectPage() {
  const fireScarsLayer = FireScarsLayer("fire-scars", "Fire Scars", fireScarsTileJson);
  return (
    <Box sx={{ height: "var(--vh100)", display: "flex", flexDirection: "column" }}>
      {/* Map centred roughly over Australia based on provided tilejson */}
      <Map layers={[fireScarsLayer]} initialZoom={3} style={{ flex: 1 }} />
      <Box sx={{ position: "fixed", top: "50%", right: 10, zIndex: 100 }}>
        <LayersToolbar layers={[fireScarsLayer]} labelSide="left" />
      </Box>
    </Box>
  );
}
